import styled from 'styled-components';

const Main = styled.div`
  max-width: 40rem;
  margin: auto;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export default Main;
